import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { AlertBannerTypes } from '@lyrahealth-inc/shared-app-logic/src/features/alerts/AlertBannerTypes'

import { AlertBanner } from './AlertBanner'
import { TargetIcon } from '../../atoms/icons/TargetIcon'
import { Link } from '../../atoms/link/Link'
import { tID } from '../../utils/utils'

const FixedHeightContainer = styled(View)({
  height: 72,
  overflow: 'hidden',
  justifyContent: 'center',
})

export type GoogleCatalystBannerProps = {
  onCatalystCoachPress: () => void
  dismissHandler: () => void
}

export const GoogleCatalystBanner: FunctionComponent<GoogleCatalystBannerProps> = ({
  onCatalystCoachPress,
  dismissHandler,
}) => {
  return (
    <FixedHeightContainer>
      <AlertBanner
        show
        style={AlertBannerTypes.NEUTRAL}
        horizontalPaddingBetweenTextAndLink={5}
        icon={<TargetIcon />}
        testID={tID('GoogleCatalystBanner')}
        inlineLinkWithText
        contents={
          <FormattedMessage
            defaultMessage='Ready to take the next step? Connect with your'
            description='Banner text prompting user to return to the Google performance coaching microsite'
          />
        }
        trailingLink={
          <Link
            text={
              <FormattedMessage
                defaultMessage='Catalyst Coach'
                description='Link text to navigate back to the Google performance coaching microsite'
              />
            }
            onPress={onCatalystCoachPress}
            underline
            medium
          />
        }
        dismissHandler={dismissHandler}
      />
    </FixedHeightContainer>
  )
}
